/**
 * src/components/ui/Checkbox.jsx — a single labelled checkbox.
 *
 * A real native `<input type="checkbox">`, styled only via `accent-color`
 * (Baseline widely available) so it inherits the OS's own check animation,
 * high-contrast-mode behaviour and touch target handling for free, rather
 * than a custom `role="checkbox"` div re-implementing all of that by hand.
 */

/**
 * @param {{
 *   label: React.ReactNode,
 *   id: string,
 *   hint?: React.ReactNode,
 * } & React.InputHTMLAttributes<HTMLInputElement>} props
 * @returns {JSX.Element}
 */
export function Checkbox({ label, id, hint, ...inputProps }) {
  const hintId = hint ? `${id}-hint` : undefined;
  return (
    <div className="ui-checkbox">
      <label className="ui-checkbox-label" htmlFor={id}>
        <input type="checkbox" id={id} aria-describedby={hintId} {...inputProps} />
        {label}
      </label>
      {hint ? (
        <p id={hintId} className="ui-field-hint ui-checkbox-hint">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
